import { MutableRefObject, useEffect, useRef, useState } from "react";

const defaultAnimations = ["expand", "down", "up"];

const useRandomAnimation = (animate?: boolean, animations = defaultAnimations, timeoutMax = 30, duration = 1000) => {
  const addTimeoutRef = useRef<NodeJS.Timeout>(null) as MutableRefObject<NodeJS.Timeout>;
  const animateRef = useRef(animate);
  const [animationClass, setAnimationClass] = useState<string | null>(null);
  const removeTimeoutRef = useRef<NodeJS.Timeout>(null) as MutableRefObject<NodeJS.Timeout>;

  useEffect(() => {
    animateRef.current = animate;

    if (!animate) {
      return;
    }

    if (animationClass) {
      removeTimeoutRef.current = setTimeout(() => {
        setAnimationClass(null);
      }, duration);
    } else {
      addTimeoutRef.current = setTimeout(() => {
        if (!animateRef.current) {
          return;
        }

        const animationIndex = Math.floor(Math.random() * animations.length);
        setAnimationClass(animations[animationIndex]);
      }, Math.floor(Math.random() * timeoutMax) * 1000);
    }
  }, [animate, animationClass, animations, timeoutMax, duration]);

  useEffect(() => {
    return () => {
      if (removeTimeoutRef.current) {
        clearTimeout(removeTimeoutRef.current);
      }
      if (addTimeoutRef.current) {
        clearTimeout(addTimeoutRef.current);
      }
    };
  }, []);

  return animationClass;
};

export default useRandomAnimation;
